import React, { useState, useEffect } from 'react';
import { Checkbox } from 'antd';
import type { CheckboxValueType } from 'antd/es/checkbox/Group';
import styled from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useQuestionStore } from 'lowcomp/plugins/member/member-questions/content/components/QuestionProvider';
import type { IOptionItem } from '@/components/AppreciationDay/index.d';

interface ICheckboxComponentProps {
    opstions: IOptionItem[];
    isMobile: boolean;
    onChange?: (val: string) => void;
}

const CheckboxComponent: React.FC<ICheckboxComponentProps> = ({ opstions, onChange }) => {
    const { question, index } = useQuestionStore();
    const { userAnswer, defAnswer } = question[index];
    const [checkValue, setCheckValue] = useState<CheckboxValueType[]>(userAnswer?.split(',') || []);

    useEffect(() => {
        setCheckValue(userAnswer?.split(',') || []);
    }, [userAnswer]);

    const onCheckboxChange = (e: CheckboxValueType[]) => {
        console.log(e);
        if (defAnswer) return;
        setCheckValue(e);
        onChange && onChange(e.join(','));
    };

    const getClassName = (optionId: string) => {
        if (!defAnswer) return '';
        if (!defAnswer.split(',').includes(optionId)) return 'error';
        return 'success';
    };

    return (
        <div className={styled.checkbox}>
            <Checkbox.Group defaultValue={checkValue} onChange={onCheckboxChange} disabled={!!defAnswer}>
                {opstions &&
                    opstions.map((item) => (
                        <div className="checkbox-item-wrap" key={`${item.optionId}${index}`}>
                            <Checkbox key={item.optionId} value={item.optionId} className={getClassName(item.optionId)}>
                                {item.optionUrl && (
                                    <div className="checkbox-item-img">
                                        <NextImage src={item.optionUrl} alt={item.optionName} aria-label={item.optionName} />
                                    </div>
                                )}
                                {item.optionSelect}.{item.optionName}
                            </Checkbox>
                        </div>
                    ))}
            </Checkbox.Group>
        </div>
    );
};

export default CheckboxComponent;
